/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'historyClose': {
    width: 32,
    height: 32,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M956.171 875.412l-80.757 80.757-363.416-363.412L148.586 956.17 67.83 875.412 431.24 512 67.829 148.587l80.757-80.757 363.412 363.412L875.414 67.83l80.757 80.757L592.756 512l363.415 363.412z"/>'
  }
})
